import { useEffect, useMemo, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import PageHeader from "../../../core/common/commonComponents/PageHeader";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { all_routes } from "../../router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import { CalendarOutlined, DollarCircleOutlined, IdcardOutlined, MoneyCollectOutlined, TeamOutlined } from "@ant-design/icons";
import { message, Select, Table, Tabs, Typography } from "antd";
import WorkforceOverview from "./WorkforceOverview";
import AttendanceOverview from "./AttendanceOverview";
import CompensationOverview from "./CompensationOverview";
import { AppDispatch } from "../../../core/data/redux/store";
import { getEmployeeByUserId } from "../../../core/data/redux/employee/employeeAction";
import { fetchAttendanceData, fetchCompensationData, fetchHRwiseAttendanceDetails, fetchHRwiseWorkforceEmployees, fetchMonthlySummaryForWorkforce, fetchResignationData } from "../../../core/data/redux/hr-dashboard/hrDashboardAction";
import FilterHeader from "../requestDashboard/FilterHeader";
import { filterData } from '../../../core/common/GlobalFunctions/tableFilters';
import { fetchAllResignations, fetchHierarchyResignationRequests, updateResignationStatus } from "../../../core/data/redux/resignation/resignationAction";
const { Title } = Typography;

const HRDashboard = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { TabPane } = Tabs;
  const [activeTab, setActiveTab] = useState('workforce');
  const { attendanceData } = useSelector((state: any) => state.dashboard.hrDashboard);
  const { user } = useSelector((state: any) => state.auth);
  const { employeesbyUser } = useSelector((state: any) => state.employee);
  const employeeId = employeesbyUser?.employeeId;
  const monthwiseData = useSelector((state: any) => state.dashboard.hrDashboard.monthwiseData);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const hrWiseResignation = useSelector((state: any) => state.dashboard.hrDashboard.hrWiseResignation);
  const [loadingIds, setLoadingIds] = useState<number[]>([]);
  const [isStatusUpdating, setIsStatusUpdating] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [selectedTableData, setSelectedTableData] = useState<any[]>([]);
  const hrEmployees = useSelector((state: any) => state.dashboard.hrDashboard.hrEmployees);
  const attendanceEmployees = useSelector((state: any) => state.dashboard.hrDashboard.attendanceEmployees);
  console.log(monthwiseData?.data?.departmentWiseAttritionRetention, 'hrEmployees employees')

  useEffect(() => {
    if (employeeId) dispatch(fetchHRwiseAttendanceDetails({ hrId: employeeId }));
  }, [dispatch, employeeId]);

  const handleCardClick = (key: string) => {
    const departmentWise =
      monthwiseData?.data?.departmentWiseAttritionRetention || [];

    if (key === "attrition") {
      setSelectedCategory("attrition");
      setSelectedTableData(
        departmentWise.map((d: any) => ({
          departmentId: d.departmentId,
          departmentName: d.departmentName,
          total_employees: d.total_employees,
          inactive_employees: d.inactive_employees,
          attrition_rate: d.attrition_rate,
        }))
      );
      return;
    }

    if (key === "retention") {
      setSelectedCategory("retention");
      setSelectedTableData(
        departmentWise.map((d: any) => ({
          departmentId: d.departmentId,
          departmentName: d.departmentName,
          total_employees: d.total_employees,
          active_employees: d.active_employees,
          retention_rate: d.retention_rate,
        }))
      );
      return;
    }

    if (!hrEmployees?.[0]) return;

    const dataMap: any = {
      active: hrEmployees[0].active_employees,
      present: hrEmployees[0].present_today,
      absent: hrEmployees[0].absent_today,
      wfh: hrEmployees[0].wfh_today,
      leave: hrEmployees[0].on_leave_today,
      onsite: hrEmployees[0].onsite_employees,
      newHires: hrEmployees[0].new_hires,
      exits: hrEmployees[0].exits
    };

    setSelectedCategory(key);
    setSelectedTableData(dataMap[key] || []);
  };

  const statusColors: { [key: string]: string } = {
    Pending: "#f0ad4e",
    Approved: "#5cb85c",
    Rejected: "#d9534f",
  };

  useEffect(() => {
    if (!employeesbyUser?.employeeId && user?.UserId) {
      dispatch(getEmployeeByUserId({ userId: user.UserId }));
    }
  }, [dispatch, employeesbyUser, user]);

  useEffect(() => {
    if (employeeId) {
      dispatch(fetchAttendanceData({ hrId: employeeId }));
    }
  }, [dispatch, employeeId]);

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().toLocaleString('default', { month: 'long' });
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const years = Array.from({ length: 14 }, (_, index) => currentYear - index);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const getMonthNumber = (monthName: string): number => {
    const monthIndex = new Date(`${monthName} 1, 2000`).getMonth();
    return monthIndex + 1;
  };
  const handleMonthSelect = (month: string) => {
    setSelectedMonth(month);
  };
  const handleYearSelect = (year: number) => {
    setSelectedYear(year);
    setSelectedMonth(currentMonth);
  };

  useEffect(() => {
    if (employeeId && selectedMonth && selectedYear) {
      const monthNum = getMonthNumber(selectedMonth);
      dispatch(fetchMonthlySummaryForWorkforce({ hrId: employeeId, year: selectedYear, month: monthNum }));
      dispatch(fetchCompensationData({ hrId: employeeId, year: selectedYear, month: monthNum }));
    }
  }, [employeeId, selectedMonth, selectedYear]);

  useEffect(() => {
    if (employeeId) {
      dispatch(fetchResignationData({ hrId: employeeId }));
      dispatch(fetchHierarchyResignationRequests({ useRouteId: employeeId, includeSelf: false }));
    }
  }, [dispatch, employeeId]);

  const filteredHierarchyHr = useMemo(() => {
    const filters = selectedStatus && selectedStatus !== "All" ? { LeaveRequestStatus: selectedStatus } : {};
    const dataArray = Array.isArray(hrWiseResignation) ? hrWiseResignation : hrWiseResignation?.data ?? [];
    return filterData(dataArray, filters, "CreatedAt", "CreatedAt", selectedSort);
  }, [hrWiseResignation, selectedStatus, selectedSort]);

  useEffect(() => setTableKey(prev => prev + 1), [filteredHierarchyHr]);
  useEffect(() => setTableKey(prev => prev + 1), [selectedTableData]);

  const getFinalStatus = (record: any) => {
    const { hod_status, hr_status, manager_status } = record;
    if ([hod_status, hr_status, manager_status].includes("Rejected")) { return "Rejected"; }
    if (hod_status === "Approved" && hr_status === "Approved" && manager_status === "Approved") { return "Approved"; }
    return "Pending";
  };

  const updateStatus = async (status: string, record: any) => {
    console.log(record, 'record')
    setLoadingIds((prev) => [...prev, record.ResignationId]);
    setIsStatusUpdating(true);

    const result = await dispatch(
      updateResignationStatus({ resignationId: record.ResignationId, status, ModifiedBy: employeeId })
    );

    if (result.meta.requestStatus === "fulfilled") {
      message.success("Resignation status updated successfully");
      await dispatch(fetchHierarchyResignationRequests({ useRouteId: employeeId, includeSelf: false }));
    } else {
      message.error("Failed to update resignation status");
    }

    setLoadingIds((prev: any) => prev.filter((id: any) => id !== record.ResignationId));
    setIsStatusUpdating(false);
  };

  useEffect(() => {
    if (employeeId) dispatch(fetchHRwiseWorkforceEmployees({ hrId: employeeId }));
  }, [dispatch, employeeId]);

  const resignationColumns = [
   {
      title: "Resignation ID",
      dataIndex: "ResignationId",
      render: (text: string, record: any) => (
        <Link to="#" className="ps-4 fw-medium text-dark">
          {record.ResignationId || "N/A"}
        </Link>
      ),
      sorter: (a: any, b: any) => a.ResignationId - b.ResignationId,
    },
    {
      title: "Employee Name",
      dataIndex: "EmployeeName",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <Link to="#" className="avatar avatar-md">
            <img
              src={
                record.PictureURL ??
                "https://cdn-icons-png.flaticon.com/512/149/149071.png"
              }
              alt="Employee"
              className="img-fluid rounded-circle"
            />
          </Link>
          <div className="ms-2">
            <Link to="#" className="fw-semibold">
              {record.EmployeeName || "N/A"}
            </Link>
            <div className="text-muted fs-12">{record.role || ""}</div>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) =>
        a.EmployeeName.localeCompare(b.EmployeeName),
    },
    {
      title: "Department",
      dataIndex: "DepartmentName",
      render: (text: string) => text || "—",
      sorter: (a: any, b: any) =>
        (a.DepartmentName || "").localeCompare(b.DepartmentName || ""),
    },
    {
      title: "Designation",
      dataIndex: "DesignationName",
      render: (text: string) => text || "—",
      sorter: (a: any, b: any) =>
        (a.DesignationName || "").localeCompare(b.DesignationName || ""),
    },
    {
      title: "Resignation Date",
      dataIndex: "ResignationDate",
      render: (text: string) =>
        text ? new Date(text).toLocaleDateString() : "—",
      sorter: (a: any, b: any) =>
        new Date(a.ResignationDate).getTime() -
        new Date(b.ResignationDate).getTime(),
    },
    {
      title: "Notice Date",
      dataIndex: "NoticeDate",
      render: (text: string) =>
        text ? new Date(text).toLocaleDateString() : "—",
      sorter: (a: any, b: any) =>
        new Date(a.NoticeDate).getTime() -
        new Date(b.NoticeDate).getTime(),
    },
    {
      title: "Status",
      dataIndex: "hr_status",
      render: (text: string, record: any) => {
        return (
          <Select
            value={record.hr_status}
            onChange={(value) => updateStatus(value, record)}
            style={{ width: 120 }}
            size="small"
            disabled={
              record.hr_status === "Approved" ||
              record.manager_status !== "Approved" ||
              record.hod_status !== "Approved" ||
              loadingIds.includes(record.ResignationId) ||
              isStatusUpdating
            }
          >
            {["Pending", "Approved", "Rejected"].map(status => (
              <Select.Option key={status} value={status}>
                <span style={{ color: statusColors[status], fontWeight: 500 }}>
                  {status}
                </span>
              </Select.Option>
            ))}
          </Select>
        )
      }
    },
    {
      title: "Final Status",
      dataIndex: "ResignationStatus",
      render: (text: string, record: any) => {
        const finalStatus = getFinalStatus(record);
        return (
          <Select value={finalStatus} style={{ width: 120 }} size="small" disabled>
            {["Pending", "Approved", "Rejected"].map((status) => (
              <Select.Option key={status} value={status}>
                <span style={{ color: status === "Pending" ? "#faad14" : status === "Approved" ? "#52c41a" : "#ff4d4f", fontWeight: 600 }}
                >
                  {status}
                </span>
              </Select.Option>
            ))}
          </Select>
        );
      },
    },
  ];

  return (
    <div className="page-wrapper" style={{ backgroundColor: '#f5f7fb', minHeight: '100vh' }}>
      <div className="content container-fluid py-4">
        <PageHeader
          title="HR Dashboard"
          breadcrumbs={[
            { label: <i className="ti ti-smart-home" />, path: all_routes.adminDashboard },
            { label: "Dashboard" },
            { label: "HR Dashboard", isActive: true },
          ]}
          addLabel="Add Tax Regime"
          rightExtra={
            <div className="d-flex align-items-center gap-2">
              <CollapseHeader />
            </div>
          }
        />

        <div className="content">
          <div className="HR-dashboard">
            {/* Header */}
            <div className="bg-white shadow-sm border-bottom mb-4">
              <div className="container-fluid">
                <div className="row align-items-center py-3">
                  <div className="col">
                    <Title level={3} className="mb-0">
                      <IdcardOutlined className="me-2 text-primary" />
                      {attendanceData?.[0]?.hrName}
                    </Title>
                  </div>
                  <div className="col-auto ms-auto d-flex align-items-center gap-2">
                    <div className="dropdown">
                      <button
                        className="btn btn-primary dropdown-toggle d-flex align-items-center"
                        type="button"
                        id="dropdownYearButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="ti ti-calendar me-2" />
                        {selectedYear}
                      </button>
                      <ul className="dropdown-menu" aria-labelledby="dropdownYearButton">
                        {years?.map((year: any, index: any) => (
                          <li key={index}>
                            <a className="dropdown-item" href="#" onClick={() => handleYearSelect(year)}>
                              {year}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="dropdown">
                      <button
                        className="btn btn-primary dropdown-toggle d-flex align-items-center"
                        type="button"
                        id="dropdownMonthButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="ti ti-calendar me-2" />
                        {selectedMonth}
                      </button>
                      <ul className="dropdown-menu" aria-labelledby="dropdownMonthButton">
                        {[
                          'January', 'February', 'March', 'April', 'May', 'June',
                          'July', 'August', 'September', 'October', 'November', 'December'
                        ].map((month, index) => (
                          <li key={index}>
                            <a className="dropdown-item" href="#" onClick={() => handleMonthSelect(month)}>
                              {month}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container-fluid">
              <Tabs
                activeKey={activeTab}
                onChange={setActiveTab}
                size="large"
                className="mb-4"
              >
                <TabPane tab={<span><TeamOutlined />{" "}Workforce</span>} key="workforce">
                  <WorkforceOverview
                    data={monthwiseData}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    selectedTableData={selectedTableData}
                    setSelectedTableData={setSelectedTableData}
                    handleCardClick={handleCardClick}
                    tableKey={tableKey}
                  />
                </TabPane>

                {/* <TabPane tab={<span><UserSwitchOutlined />{" "}Recruitment</span>} key="recruitment">
                  <RecruitmentHiring />
                </TabPane> */}

                <TabPane tab={<span><CalendarOutlined />{" "}Attendance</span>} key="attendance">
                  <AttendanceOverview />
                </TabPane>

                {/* <TabPane tab={<span><BarChartOutlined />{" "}Performance</span>} key="performance">
                  <PerformanceOverview />
                </TabPane> */}

                {/* <TabPane tab={<span><SmileOutlined />{" "}Engagement</span>} key="engagement">
                  <EngagementOverview />
                </TabPane> */}

                <TabPane tab={<span><MoneyCollectOutlined />{" "}Compensation</span>} key="compensation">
                  <CompensationOverview />
                </TabPane>

                <TabPane tab={<span><TeamOutlined />{" "}Resignation Requests</span>} key="resignation">
                  <div className="row mb-4">
                    {/* {getStatusCards(filteredHierarchyHr, "LeaveRequestStatus")} */}
                  </div>
                  <div className="card">
                    <FilterHeader
                      selectedStatus={selectedStatus}
                      setSelectedStatus={setSelectedStatus}
                      selectedSort={selectedSort}
                      setSelectedSort={setSelectedSort}
                    />
                    <div className="card-body p-0">
                      <Table
                        dataSource={filteredHierarchyHr || []}
                        columns={resignationColumns}
                        rowKey="ResignationId"
                        pagination={false}
                      />
                    </div>
                  </div>
                </TabPane>

                {/* <TabPane tab={<span><SafetyCertificateOutlined />{" "}Compliance</span>} key="compliance">
                  <ComplianceOverview />
                </TabPane> */}

                {/* <TabPane tab={<span><LineChartOutlined />{" "}Predictive Insights</span>} key="predictive">
                  <PredictiveInsightsOverview />
                </TabPane> */}
              </Tabs>
            </div>
          </div>
        </div>

      </div>
      {/* Footer */}
      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0">2024 - 2025© hrmtree.</p>
        <p>
          Developed By{" "}
          <Link to="#" className="text-primary">
            Leadchain Systems
          </Link>
        </p>
      </div>
    </div>
  );
};

export default HRDashboard;
